import { RiskLevel } from "./risk-level";

export class AnalysisResult {
  name: string;
  level: RiskLevel;
  additionalInfo?: any;
  description: string;
  weight: number;

  constructor(name: string, level: RiskLevel, weight: number, description: string, info?: any) {
    this.name = name;
    this.level = level;
    this.weight = weight;
    this.description = description;
    this.additionalInfo = info;
  }
}
